import { createRoute, useParams } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { UserDetailView } from "@/features/admin/components/user-detail/user-detail-view";
import { PageContainer } from "@fleet/ui";

function AdminUserDetailPage() {
  const params = useParams({ from: "/_app/admin/users/$userId" });
  return (
    <PageContainer maxWidth="4xl">
      <UserDetailView userId={params().userId} />
    </PageContainer>
  );
}

export const adminUserDetailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/users/$userId",
  component: AdminUserDetailPage,
});
